'use strict';

(function () {
  'use strict';
  /**
   * The header + overlay
   */

  angular.module('youth').directive('navHeader', ['navSvc', '$document', '$rootScope', function (navSvc, $document, $rootScope) {
    return {
      templateUrl: 'youth/templates/nav-header.html',
      replace: true,
      restrict: 'A',
      scope: {},
      controller: 'NavHeaderCtrl',
      controllerAs: 'nav',
      link: function link(scope) {
        $document.bind('keypress', function (e) {
          if (e.keyCode === 27) {
            navSvc.close();
            scope.$apply();
          }
        });
        $rootScope.$on('$stateChangeStart', function () {
          navSvc.close();
        });
        navSvc.setCallback(function (show) {
          scope.show = show;
        });
      }
    };
  }]).controller('NavHeaderCtrl', NavHeaderCtrl);

  NavHeaderCtrl.$inject = ['userSvc', '$state', 'NotifyingSvc'];

  function NavHeaderCtrl(userSvc, $state, NotifyingSvc) {
    var vm = this;

    userSvc.getUser().then(function (user) {
      vm.user = user;
    });

    NotifyingSvc.subscribe(NotifyingSvc.EVENTS.SEARCH_RESULTS, function (event, data) {
      var searchData = {};
      searchData.searchPending = false;
      searchData.query = data.query;
      searchData.hits = data.hits;
      searchData.records = data.records;
      $state.go('activitySearchPage', { data: searchData });
    });
  }
})();